import React from 'react';
import * as R from 'ramda';
import { Popover } from 'antd';
import { node as nodeElement, object } from 'prop-types';

import { truncate, capitalize } from '../../../utils';
import { PROJECT_STATE_VALUE } from '../../../api/constants';

import {
  ContentWrapper,
  InfoWrapper,
  Key,
  Value,
  StyledLink,
} from '../../ui-helpers';


export const OptionPopover = ({ children, project }) => (
  <Popover
    trigger="hover"
    placement="bottomLeft"
    overlayStyle={{ zIndex: 1200 }}
    content={
      <ContentWrapper>
        <div>
          <InfoWrapper>
            <Key>Name:</Key>
            <Value>{project.name && truncate(project.name)}</Value>
          </InfoWrapper>

          <InfoWrapper>
            <Key>Status:</Key>
            <Value>
              <span style={{ color: R.prop('color', PROJECT_STATE_VALUE[project.status]) }}>
                {capitalize(project.status)}
              </span>
            </Value>
          </InfoWrapper>

          <InfoWrapper>
            <Key>Description:</Key>
            <Value>
              {project.description && project.description.trim().length
                ? truncate(project.description, 200)
                : 'No description provided...'}
            </Value>
          </InfoWrapper>
        </div>
        <StyledLink
          target="_blank"
          href={project.url}
        >
          Open project
        </StyledLink>
      </ContentWrapper>
    }
  >
    {children}
  </Popover>
);

OptionPopover.propTypes = {
  project: object.isRequired,
  children: nodeElement.isRequired,
};

OptionPopover.defaultProps = {};



// WEBPACK FOOTER //
// ./src/components/request-form/project-info-popover/index.js